<template>
  <div class="month-data">
    <!-- 时间 -->
    <div class="time-choice" @click="calendar_show = true">
      <span>{{date}}</span>
      <img :src="IconMenu" />
    </div>
    <!-- 折线图 -->
    <div class="chart-box">
      <canvas id="month-data"></canvas>
    </div>
    <!-- 日历 -->
    <van-popup v-model="calendar_show" position="bottom">
      <van-picker :columns="columns" show-toolbar @cancel="calendar_show = false" @confirm="DateConfirm" />
      <!-- <Calendar class="calendar-box" @choseDay="calendar_show = false" /> -->
    </van-popup>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  // import data from './month_data'
  const F2 = require('@antv/f2/lib/index')

  export default {
    data () {
      const month = []
      for (let i = 1; i <= 12; i++) {
        month.push(`${i < 10 ? '0' : ''}${i}`)
      }
      const year = []
      for (let i = new Date().getFullYear(); i >= 2000; i--) {
        year.push(i)
      }
      return {
        calendar_show: false,
        columns: [
          { values: year },
          { values: month }
        ],
        data: [],
        date: this.$Tool.FormatTime(new Date(), 'YYYY-MM')
      }
    },
    methods: {
      InitData () {
        const chart = new F2.Chart({
          id: 'month-data',
          pixelRatio: window.devicePixelRatio
        })
        chart.source(this.data, {
          x: {
            range: [0, 1],
            tickCount: 7
          },
          y: {
            alias: '饮水总量(L)',
            min: 0,
            minLimit: 0
          }
        })
        chart.line().position('x*y')
        chart.render()
      },
      DateConfirm (e) {
        this.date = e[0] + '-' + e[1]
        this.calendar_show = false
      },
      WaterGetMonth () {
        this.$Get('Common.WaterGetMonth', {
          cup_id: this.$route.query.id,
          month: this.date
        }).then(({ data: { data } }) => {
          this.data = data.map(item => ({
            ...item,
            y: Number(item.y / 1000).toFixed(2) * 1
          }))
          this.InitData()
        })
      }
    },
    watch: {
      date (to, from) {
        if (to !== from) {
          this.WaterGetMonth()
        }
      }
    },
    computed: {
      ...SetImage(['IconMenu'])
    },
    mounted () {
      this.WaterGetMonth()
    }
  }
</script>

<style lang="less" scoped>
  .month-data {
    .p(.5rem .1rem);
    .calendar-box /deep/ .wh_content_all {
      .bg(#00b0f4);
      .wh_isToday {
        .bg(#fff);
        .c(#333);
      }
    }
    .time-choice {
      .w(4.44rem);
      .h(.7rem);
      .br(.1rem);
      .bg(#f4f4f4);
      .m(0 auto .47rem);
      .flex-cc();
      .fz(.26rem);
      .c(#333);
      img {
        .w(.2rem);
        .h(.12rem);
        .ml(.37rem);
      }
    }
    .chart-box {
      .w();
      .h(5.05rem);
      canvas {
        .w();
        .h();
      }
    }
  }
</style>
